
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function BookingSuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // التنقل التلقائي للصفحة الرئيسية بعد 5 ثوانٍ
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#007AFF]/10 to-[#34C759]/10 flex items-center justify-center px-4">
      <div className="bg-white rounded-3xl p-8 text-center shadow-xl max-w-sm w-full">
        {/* أيقونة النجاح */}
        <div className="w-20 h-20 bg-[#34C759] rounded-full mx-auto mb-6 flex items-center justify-center">
          <i className="ri-check-line text-white text-4xl"></i>
        </div>

        {/* العنوان الرئيسي */}
        <h1 className="text-2xl font-bold text-[#333333] mb-4">
          تم تأكيد حجزك بنجاح!
        </h1>

        {/* الوصف */}
        <p className="text-[#7A7A7A] mb-6 leading-relaxed">
          شكراً لك على استخدام تكافل بلس. سيتم التواصل معك قريباً لتأكيد موعدك.
        </p>

        {/* معلومات إضافية */}
        <div className="bg-[#007AFF]/5 rounded-xl p-4 mb-6">
          <div className="flex items-center justify-center gap-2 text-[#007AFF] mb-2">
            <i className="ri-time-line"></i>
            <span className="text-sm font-medium">سيتم التواصل معك خلال 24 ساعة</span>
          </div>
          <div className="flex items-center justify-center gap-2 text-[#007AFF]">
            <i className="ri-phone-line"></i>
            <span className="text-sm font-medium">تحقق من رسائلك النصية</span>
          </div>
        </div>

        {/* أزرار التنقل */}
        <div className="space-y-3">
          <Button
            variant="primary"
            size="lg"
            onClick={() => navigate('/')}
            className="w-full"
          >
            العودة للصفحة الرئيسية
          </Button>
          
          <Button
            variant="outline"
            size="lg"
            onClick={() => navigate('/tracking')}
            className="w-full"
          >
            متابعة حجوزاتي
          </Button>
        </div>

        {/* مؤشر العد التنازلي */}
        <p className="text-xs text-[#7A7A7A] mt-4">
          سيتم التوجيه تلقائياً للصفحة الرئيسية خلال 5 ثوانٍ
        </p>
      </div>
    </div>
  );
}
